const SectionFaq = Class(
    /**
     * @lends {SectionFaq#}
     */
    {
        bodyClass: 'small-nav grey',

        __construct: function () {
            this.node = mkE({
                tag: 'div',
                className: 'faq-page'
            })
        },

        draw: function() {
            const FAQ = new T.FAQ({
                title: D.Lang.get('faq.title'),
                intro: D.Lang.get('faq.caption'),
                prefix: 'faq'
            });
            FAQ.append(this.node);
            this.node.append(this.layout.ct());
            this.ready();
        }
    },
    Section
);
